import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CmsService, CurrencyService, RoutingService } from '@spartacus/core';
import { Observable, combineLatest, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthRedirectStorageService } from 'src/app/service/auth/auth-redirect-storage.service';
import { ShimanoAuthRedirectService } from 'src/app/service/auth/shimano-auth-redirect.service';
import { ComponentService } from 'src/app/service/component.service';
import { LanguageExtendService } from 'src/app/service/language/language-extend.service';
import { StorageService } from 'src/app/service/storage/storage.service';
import { TermsAndConditionsService } from 'src/app/service/terms-and-conditions/terms-and-conditions.service';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from '../../asm/asm-constant';

@Injectable({
  providedIn: 'root',
})
export class TCAcceptIsValidatedGuard {
  constructor(
    protected routingService: RoutingService,
    protected tcService: TermsAndConditionsService,
    private currencyService: CurrencyService,
    private langService: LanguageExtendService,
    protected cms: CmsService,
    private componentService: ComponentService,
    private authRedirectStorageService: AuthRedirectStorageService,
    private authRedirectService: ShimanoAuthRedirectService,
    private router: Router,
    private storageService: StorageService
  ) {
    // Set currency again when user open a new tab
    if (this.storageService.getLocalStorageItem('userCurrency') !== null) {
      this.currencyService.setActive(this.storageService.getLocalStorageItem('userCurrency'));
    }
  }

  canActivate(): Observable<boolean> {
    const asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);
    if (asmEnabled === 'true') {
      this.cms.getCurrentPage().subscribe((page) => {
        if (page) {
          if (page.template !== 'DealerSelectionPageTemplate') {
            this.componentService.setSiteLogoLinkDisable(false);
          } else {
            this.componentService.setSiteLogoLinkDisable(true);
          }

          if (
            page.template === 'LandingPage2Template' &&
            this.storageService.getSessionStorageItem('asmReload') !== null
          ) {
            const el = document.getElementsByClassName('LandingPage2Template')[0] as HTMLElement;
            el.classList.add('d-none');
            this.storageService.removeSessionStorageItem('asmReload');
            location.reload();
          }
        }
      });
      this.storageService.removeLocalStorageItem('showTCAccept');
      return of(true);
    }
    return combineLatest([
      this.langService.getShimanoActiveLanguage(),
      this.tcService.getTCVersionStatus(),
      this.authRedirectStorageService.getRedirectUrl(),
    ]).pipe(
      map(([tc, version, redirectUrl]: [any, any, string]) => {
        this.storageService.removeLocalStorageItem('showTCAccept');
        if (tc.tncVersionNo && tc.tncAcceptedDate && version) {
          return this.checkRedirectUrl(redirectUrl);
        } else if (!version || typeof tc.tncAcceptedDate === 'undefined') {
          this.storageService.setLocalStorageitem('showTCAccept', 'true');
          let returnPage: boolean;
          this.routingService
            .getNextPageContext()
            .pipe(take(1))
            .subscribe((data) => {
              if (data.id !== '/terms-and-conditions') {
                this.router.navigate(['/terms-and-conditions']);
                returnPage = false;
              }
              returnPage = true;
            });
          return returnPage;
        } else {
          return this.checkRedirectUrl(redirectUrl);
        }
      })
    );
  }

  checkRedirectUrl(redirectUrl: string): boolean {
    if (redirectUrl && redirectUrl.length) {
      this.authRedirectService.redirect();
      return false;
    } else {
      return true;
    }
  }
}
